import { render, staticRenderFns } from "./selectPage.vue?vue&type=template&id=968500aa"
import script from "./selectPage.vue?vue&type=script&lang=js"
export * from "./selectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('968500aa')) {
      api.createRecord('968500aa', component.options)
    } else {
      api.reload('968500aa', component.options)
    }
    module.hot.accept("./selectPage.vue?vue&type=template&id=968500aa", function () {
      api.rerender('968500aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminCom/selectPage.vue"
export default component.exports